export default {
  opBtn: {
    marginRight: 5,
  },
  opBtnLength: 80
};



// WEBPACK FOOTER //
// ./src/Parts/TablePart/style.js